import {FacturesResultatsComponent} from "./resultats/factures-resultats.component";
import {RechercheFactureDto} from "@resources/resources";
import {ArianeElement, ArianeStore} from "@digicerba/common";
import {Component, ViewChild} from "@angular/core";

@Component({
  selector: 'factures',
  templateUrl: './factures.component.html',
  host: {'class': 'page'}
})
export class FacturesComponent {

  rechercheFactureDto: RechercheFactureDto = null;
  @ViewChild(FacturesResultatsComponent) resultats: FacturesResultatsComponent;

  constructor(arianeStore: ArianeStore) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.FACTURES",
        route: "/"
      }
    ]
    arianeStore.updateElements(arianeElements);
  }

  filtreData(rechercheDto: RechercheFactureDto) {
    this.rechercheFactureDto = rechercheDto;
  }

  totalElements() {
    return this.resultats.asiTableData.totalElements;
  }

  nbSelected() {
    return this.resultats.selectionModel.nbItemsSelected;
  }

  telechargerSelection() {
    this.resultats.telechargerSelection();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/pages/cerba/pages/factures/factures.component.ts